import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;
const getVendorList = (page, pagesize, search, ordering) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/vendor/`, {
        headers: authHeader(),
        params: {
            deleted: 0,
            page: page,
            pagesize: pagesize,
            search: search, // You might want to include search here, if applicable
            ordering: ordering
        },
    });
};

const getVendorDropdown = (page, pagesize, search, ordering) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/customer/`, {
        headers: authHeader(),
        params: {
            //fields: 'id,vendor_trade_name,deleted',
            page: page,
            pagesize: pagesize,
            search: search, // You might want to include search here, if applicable
            ordering: ordering,
            company_type: "vendor"
        },
    });
};

const getVendorArchiveList = (page, pagesize, search, ordering) => {
    return axios.get(API_URL + '/api/' + API_VERSION + '/vendor/?deleted=1', {
        headers: authHeader(), params: {
            page: page,
            pagesize: pagesize,
            search: search,
            ordering: ordering
        }
    });
};

const getVendorById = (id) => {
    return axios.get(`${API_URL}/api/${API_VERSION}/vendor/`, {
        headers: authHeader(), params: {
            id: id
        }
    });
};
const editVendor = (id, formPayload) => {
    return axios.patch(
        `${API_URL}/api/${API_VERSION}/vendor/${id}/`,
        formPayload,
        { headers: authHeader() }
    );
};
const createVendor = (formData) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/vendor/`,
        formData,
        {
            headers: authHeader(),
        },
    );
};
const deleteVendor = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/vendor/${id}/archive/`, // Include the die group's ID in the URL
        {},
        { headers: authHeader() } // Authentication header
    );
};
const unArchiveVendor = (id) => {
    return axios.post(
        `${API_URL}/api/${API_VERSION}/vendor/${id}/unarchive/`, // Include the die group's ID in the URL
        {}, // Pass an empty object if no data needs to be sent
        { headers: authHeader() } // Authentication header
    );
};

const vendorService = {
    getVendorList,
    getVendorArchiveList,
    getVendorById,
    createVendor,
    editVendor,
    deleteVendor,
    unArchiveVendor,
    getVendorDropdown,
};

export default vendorService;
